<template>
    <div class="container about" >
        <div class="row d-flex align-items-start mt-4" style="max-width: inherit;">
            <div class="d-flex justify-content-start">
                <h5 class="fw-bold fs-md">Videos</h5>
            </div>
            <div class="d-flex justify-content-between" style="overflow: scroll;">
                <div class="Col-12 col-lg-4 m-2 m-md-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/8w0nSV7UjMA?si=LcwSTUxvG8paPCEf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-lg-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/gm-hKgfZOek?si=S3Sv3i7NfDs3mEp3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-lg-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/9OIW0ZZhgVs?si=Ft7aJMZQzDHWRGGE" title="YouTube video player" frameborder="0" allow="accelerometer; 200play; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-md-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/XgFjrrgXfTE?si=md5tX4gohOgSBp68" title="YouTube video player" frameborder="0" allow="accelerometer; 200play; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-md-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/06t-hFiIJ2M?si=7Nt5SNgssZ71AmEn" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-md-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/_1Bh7ksQWps?si=lJwFXvCDGhui9tN2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-md-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/Ssw4fs5nhn0?si=WMFuN00e7Cj0-AVT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <div class="Col-12 col-lg-4 m-2 m-md-3">
                    <iframe width="450" height="250" src="https://www.youtube.com/embed/1_ciOQNSSUo?si=G8pLcbQIAVrP8A5K" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
        </div>

        <section class="reels-section" aria-labelledby="reels-heading">
            <div class="reels-header">
                <div>
                    <h5 id="reels-heading">Reels</h5>
                    <div>Real Life Impact Stories from Smallholder Farmers.</div>
                </div>
                <div class="reels-controls" aria-label="Browse reels">
                    <button type="button" :disabled="atStart" @click="scrollReels(-1)" aria-label="Previous reels" aria-controls="reels-track">
                        <i class="bi bi-arrow-left" aria-hidden="true"></i>
                    </button>
                    <button type="button" :disabled="atEnd" @click="scrollReels(1)" aria-label="Next reels" aria-controls="reels-track">
                        <i class="bi bi-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div id="reels-track" ref="reelsTrack" class="reels-track" @scroll.passive="updateScrollPosition">
                <article class="reel-card" v-for="(reel, index) in reels" :key="reel.id">
                    <div class="reel-media">
                        <iframe
                            v-if="activeReel === reel.id"
                            :key="reel.id"
                            class="reel-player"
                            :src="`https://www.tiktok.com/player/v1/${reel.id}?autoplay=1&muted=1&description=1`"
                            :title="`Agro Innova reel ${index + 1}`"
                            allow="autoplay; fullscreen"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                        ></iframe>
                        <button v-else type="button" class="reel-preview" @click="activeReel = reel.id" :aria-label="`Play Agro Innova reel ${index + 1}`">
                            <img class="reel-thumbnail" :src="reel.thumbnail" :alt="reel.title || `Agro Innova reel ${index + 1} preview`" loading="lazy" />
                            <span class="reel-shade" aria-hidden="true"></span>
                            <span class="reel-brand">AGRO INNOVA</span>

                            <span class="reel-play"><i class="bi bi-play-fill" aria-hidden="true"></i></span>
                            <span class="reel-prompt">Play reel</span>
                            <span class="reel-account">@agroinnovaltd</span>
                        </button>
                    </div>
                    <div class="reel-footer">
                        <span>Reel {{ String(index + 1).padStart(2, '0') }}</span>
                        <a :href="`https://www.tiktok.com/@agroinnovaltd/video/${reel.id}`" target="_blank" rel="noopener noreferrer" :aria-label="`Watch reel ${index + 1} on TikTok (opens in a new tab)`">
                            TikTok <i class="bi bi-arrow-up-right" aria-hidden="true"></i>
                        </a>
                        <button v-if="activeReel === reel.id" type="button" class="reel-close" @click="activeReel = null" :aria-label="`Close reel ${index + 1}`">Close</button>
                    </div>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
import reels from '@/data/reels.json';

export default {
    name: "Videos",
    data() {
        return {
            activeReel: null,
            atStart: true,
            atEnd: false,
            reels
        }
    },
    mounted() {
        this.updateScrollPosition();
        this.reelsObserver = new ResizeObserver(() => this.updateScrollPosition());
        this.reelsObserver.observe(this.$refs.reelsTrack);
    },
    beforeUnmount() {
        this.reelsObserver?.disconnect();
    },
    methods: {
        updateScrollPosition() {
            const track = this.$refs.reelsTrack;
            if (!track) return;
            this.atStart = track.scrollLeft <= 2;
            this.atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        },
        scrollReels(direction) {
            const track = this.$refs.reelsTrack;
            const card = track.querySelector('.reel-card');
            if (!card) return;
            const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            track.scrollBy({
                left: direction * (card.offsetWidth + gap),
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
        }
    }
}
</script>

<style scoped>
.reels-section { margin-top: 48px; margin-bottom: 24px; }
.reels-header { display: flex; align-items: center; justify-content: space-between; gap: 24px; margin-bottom: 24px; text-align: left; }
.reels-header h5 { margin: 0 0 8px; font-size: 24px; font-weight: 700; color: #2a2c39; }
.reels-header p { margin: 0; color: #64716c; font-size: 15px; }
.reels-controls { display: flex; gap: 10px; flex-shrink: 0; }
.reels-controls button { width: 44px; height: 44px; border: 1px solid #d4e3dc; border-radius: 50%; background: #fff; color: #245447; }
.reels-controls button:hover:not(:disabled) { background: #e8f4ed; }
.reels-controls button:disabled { opacity: .35; cursor: default; }
.reels-track { display: flex; gap: 20px; overflow-x: auto; scroll-snap-type: x mandatory; scrollbar-width: thin; scrollbar-color: #9ebfaf #edf3ef; padding: 4px 4px 18px; }
.reel-card { flex: 0 0 calc((100% - 60px) / 4); min-width: 0; scroll-snap-align: start; border: 1px solid #e0e9e4; border-radius: 16px; overflow: hidden; background: #fff; }
.reel-media { aspect-ratio: 9 / 16; position: relative; background: #173f34; }
.reel-player { display: block; width: 100%; height: 100%; border: 0; position: absolute; inset: 0; }
.reel-preview { position: absolute; inset: 0; width: 100%; border: 0; padding: 24px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; background: radial-gradient(ellipse at top right, #437f67 0%, transparent 65%), linear-gradient(155deg, #214f40, #102d27); }
.reel-card:nth-child(even) .reel-preview { background: radial-gradient(ellipse at bottom left, #4c7b5b 0%, transparent 65%), linear-gradient(155deg, #16382e, #28594a); }
.reel-brand { position: absolute; top: 24px; left: 24px; font-size: 11px; font-weight: 600; letter-spacing: 2px; }
.reel-thumbnail { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.reel-shade { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(0,0,0,.35), rgba(0,0,0,.05) 40%, rgba(0,0,0,.6)); }
.reel-play, .reel-prompt { position: relative; }
.reel-play { display: grid; place-items: center; width: 64px; height: 64px; border-radius: 50%; background: #fff; color: #235746; font-size: 32px; transition: transform .2s; }
.reel-preview:hover .reel-play { transform: scale(1.08); }
.reel-prompt { margin-top: 16px; font-size: 16px; font-weight: 600; }
.reel-account { position: absolute; bottom: 24px; left: 24px; font-size: 12px; color: #d0e3d8; }
.reel-footer { min-height: 60px; display: flex; align-items: center; gap: 12px; padding: 14px 16px; font-size: 13px; }
.reel-footer > span { color: #64716c; margin-right: auto; }
.reel-footer a { color: #245447; font-weight: 600; text-decoration: none; white-space: nowrap; }
.reel-close { border: 0; padding: 0; background: transparent; color: #245447; text-decoration: underline; }
.reels-section button:focus-visible, .reel-footer a:focus-visible { outline: 3px solid #3db49d; outline-offset: -4px; }
@media (max-width: 1199px) { .reel-card { flex-basis: calc((100% - 40px) / 3); } }
@media (max-width: 767px) { .reel-card { flex-basis: calc((100% - 20px) / 2); } .reels-header { align-items: flex-start; gap: 12px; } }
@media (max-width: 575px) { .reel-card { flex-basis: 85%; } .reels-header p { max-width: 230px; } .reels-controls { gap: 6px; } .reels-controls button { width: 38px; height: 38px; } .reels-track { gap: 14px; } }
@media (prefers-reduced-motion: reduce) { .reel-play { transition: none; } }
</style>
